<template>
  <main>
    <MainCreativity />
  </main>
</template>

<script>
const MainCreativity = () => import('@/components/Creativity/Main')

export default {
  components: {
    MainCreativity
  },
  metaInfo: {
    meta: [
      { name: 'publisher', content: 'admanawards.com/' },
      { name: 'og:title', content: 'Creativity Day 2019 วันความคิดสร้างสรรค์แห่งชาติ 2019' },
      { name: 'og:description', content: 'หากคุณเชื่อในพลังของความคิดสร้างสรรค์ นี่คือวันที่คุณจะค้นพบแรงบันดาลใจอีกครั้ง' },
      { name: 'og:image', content: 'https://admanawards.com/img/og_thumbnail.png' },
      { name: "og:site_name'", content: 'AdmanAwards' },
      { name: 'og:type', content: 'website' }
      // you can also add open graph tags here
    ]
  }
}
</script>
